exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form>.btn[data-v-1bdc1de5]{background-color:var(--color-white,#fff);color:var(--color-curious-blue,#2286c3);border:1px solid var(--color-curious-blue,#2286c3)}form>.btn[data-v-1bdc1de5]:hover,form>div>div>label[data-v-1bdc1de5],form>div>div>span[data-v-1bdc1de5]{background-color:var(--color-curious-blue,#2286c3);color:var(--color-white,#fff)}form>div>div>label[data-v-1bdc1de5],form>div>div>span[data-v-1bdc1de5]{border-color:var(--color-curious-blue,#2286c3)}form>div>div>span.customized-span[data-v-1bdc1de5]{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}form>div>input[data-v-1bdc1de5],form>div>select[data-v-1bdc1de5]{border-color:var(--color-curious-blue,#2286c3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bdc1de5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/promotions/components/Create.vue
// module id = 645
// module chunks = 0